import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { StyleSheet, css } from 'aphrodite';
import { Font, Text, Color, Layout, Flexbox, Responsive } from './Styles';

import Image from './Image';
import PrimaryButton from './PrimaryButton';
import Locale from './models/Locale';

import ScrollFix from './ScrollFix';

const tutorialPages = {'en': [
    {
      title: "Welcome to Get Ready!",
      image: {src: null},
      text: ["The object of the game is to choose a combination of actions that help you prepare for the natural hazards in your community. Complete all six locations to win the game!"],
    },
    {
      title: "Locations",
      image: {src: "tutorial_location_en.png", width: 700, height: 539},
      text: ["There are six different locations you can play through – but they must be unlocked! Every community you visit will have different characteristics and hazards to prepare for. In each location, your preparedness and quality of life values reset. Are you up to the challenge?"],
    },
    {
      title: "Risk Profiles",
      image: {src: "tutorial_risks_en.png", width: 610, height: 845},
      text: ["Read your community risk profile to see which three hazards you will face within the level (for example: winter storm, wind storm, and extreme temperatures). The events you will encounter in the game will be related to each hazard, so it is important to collect a diverse set of actions that prepare you for the various ways that a hazard could affect you and your home."],
    },
    {
      title: "Status",
      image: {src: "tutorial_status_en.png", width: 700, height: 109},
      text: ["Check on your status in the top left corner of the screen. You have status bars for your money, your preparedness, and your quality of life.",
        "Preparedness represents how ready you are to face the hazards and events in the game.",
        "Quality of life represents your day-to-day functionality, health, as well as psychological aspects such as happiness and stress.",
        "Money represents your bank account and your budget for investing in preparedness actions.",
        "Your status for Quality of Life, Preparedness, and your bank account are closely intertwined. Often, when you invest in preparedness actions, it can be expensive and means that other lifestyle sacrifices must be made. On the other hand, there are a lot of cheap or free ways to prepare that can enhance your quality of life by making you feel safe, happy, and secure, while saving you money."],
    },
    {
      title: "Taking a Turn",
      image: {src: "tutorial_wheel_en.png", width: 523, height: 527},
      text: ["At the start of each turn, you will spin the wheel and collect $100. You will land on either an Action, and Event, or Chance."],
    },
    {
      title: "Spinning An Action",
      image: {src: "tutorial_actions_en.png", width: 701, height: 291},
      text: ["If you spin an Action, you will have the opportunity to select an action for your toolbox.  Actions allow you to either improve your home (e.g. disconnect your downspout), or adapt your lifestyle (e.g. set up a phone tree in case of emergency). Some actions cost money, others are free. See your actions at any time by clicking on the Action Toolbox button at the top right of your screen."],
    },
    {
      title: "Spinning An Event",
      image: {src: "tutorial_events_en.png", width: 562, height: 618},
      text: ["This is what the game is all about! If you spin an event, it means a certain hazard has had an impact on your community. Events range from power outages, fires, basement flooding, road closures, and more. Watch out – events like this affect us in both our preparedness and quality of life…so be prepared to lose some points! The more prepared you are, the fewer points you will lose from when an event occurs."],
    },
    {
      title: "Report Card",
      image: {src: "tutorial_reportcard_en.png", width: 699, height: 363},
      text: ["After the event, you will get a report card. This will show you whether the actions in your toolbox helped you prepare for the event. If you had actions that helped you be more prepared, you’ll gain back the points you lost, and you’ll pass the level! Successfully prepare for an event in order to unlock the next level."],
    },
    {
      title: "Winning The Game",
      image: {src: null},
      text: ["Individual locations are unlocked by selecting actions that best prepare you for the events you experience. There are a lot of actions to choose from, so don’t give up – it could take a few tries. Get through all six locations to win the game. If your Quality of Life, Preparedness or bank account go below zero, you will lose the game and must replay your current level.",
        "Don’t forget to share your scores on social media and invite your friends to test their preparedness as well!",
        "Now you’re ready to play!"],
    },
  ],
  'fr': [
    {
      title: "Tutoriel",
      image: {src: null},
      text: ["À vos marques! vous souhaite la bienvenue!",
        "L’objectif du jeu est de choisir une combinaison d’actions qui vous permettra de vous préparer en vue des dangers naturels pouvant survenir dans votre communauté. Relevez avec succès les défis aux six emplacements pour gagner le jeu!"],
    },
    {
      title: "Emplacements",
      image: {src: "tutorial_location_fr.png", width: 951, height: 622},
      text: ["Le jeu vous propose six différents emplacements, mais ils doivent être déverrouillés! Dans chaque emplacement, vos valeurs de préparation et de qualité de vie seront réinitialisées. Les caractéristiques et les risques que vous devrez affronter changent d’une communauté à l’autre. Êtes-vous prêt à relever le défi?"],
    },
    {
      title: "Profil de risque",
      image: {src: "tutorial_risks_fr.png", width: 542, height: 881},
      text: ["Lisez le profil de risque de la communauté pour connaître les trois risques que vous devrez affronter dans ce niveau (par exemple, tempête hivernale, tempête de vent et températures extrêmes). Les événements que vous rencontrerez dans le jeu correspondent à chaque risque. Il est donc important d’accumuler une série diversifiée d’actions pour vous préparer aux différentes conséquences que le risque peut avoir sur vous et votre maison."],
    },
    {
      title: "Barres d’état",
      image: {src: "tutorial_status_fr.png", width: 871, height: 124},
      text: ["Vérifiez votre état dans le coin supérieur gauche de l’écran. Des barres d’état sont prévues pour votre argent, votre préparation et votre qualité de vie.",
        "L’état de préparation représente votre niveau de préparation pour réagir aux risques et aux événements dans le jeu.",
        "La qualité de vie représente votre quotidien, votre santé ainsi que les aspects psychologiques, comme le bonheur et le stress.",
        "L'argent représente votre compte bancaire et le budget disponible pour investir dans des actions de préparation aux situations d'urgence.",
        "Les états relatifs à la qualité de vie, à la préparation et au compte de banque sont étroitement liés. Les actions de préparation coûtent souvent très cher. Par conséquent, si vous investissez dans ces actions, d’autres sacrifices devront être faits au mode de vie. En revanche, il y a beaucoup de façons économiques ou gratuites d’améliorer votre état de préparation qui rehaussent aussi votre qualité de vie en vous donnant un sentiment de sécurité, de bonheur et d’assurance, tout en économisant de l’argent."],
    },
    {
      title: "Tour de jeu",
      image: {src: "tutorial_wheel_fr.png", width: 509, height: 462},
      text: ["Au début de chaque tour, vous tournerez une roue et obtiendrez 100 $. Vous pouvez tomber sur Action, Événement ou Chance."],
    },
    {
      title: "Action",
      image: {src: "tutorial_actions_fr.png", width: 701, height: 263},
      text: ["Si la roue s’arrête sur Action, vous aurez l’occasion de choisir une action pour votre boîte. Les actions vous permettent d’améliorer votre maison (p. ex., débrancher les tuyaux de descente) ou de modifier votre mode de vie (p. ex., organiser une chaîne téléphonique en cas d’urgence). Certaines actions coûtent de l’argent, tandis que d’autres sont gratuites. Voyez les actions que vous avez selectionnées à tout moment en cliquant sur la boîte à outils située dans le coin supérieur droit de votre écran."],
    },
    {
      title: "Événement",
      image: {src: "tutorial_events_fr.png", width: 483, height: 454},
      text: ["C’est la raison d’être du jeu! Si la roue s’arrête sur Événement, cela veut dire qu’un danger quelconque a touché votre communauté. Les événements peuvent comprendre les pannes de courant, les incendies, les inondations au sous-sol, les fermetures de routes, et plus. Attention! Ces événements touchent votre état de préparation et votre qualité de vie… attendez-vous donc à perdre des points! Plus vous êtes préparé, moins vous perdrez de points à cause d’un événement."],
    },
    {
      title: "Bilan",
      image: {src: "tutorial_reportcard_fr.png", width: 699, height: 354},
      text: ["Après l’événement, vous recevrez un bilan. Celui-ci vous indiquera si les actions dans votre boîte vous ont aidé à vous préparer pour l’événement. Si vous aviez des actions qui vous ont aidé à être mieux préparé, vous pourrez récupérer les points perdus, et vous réussirez le niveau! Préparez-vous adéquatement pour un événement afin de déverrouiller le prochain niveau."],
    },
    {
      title: "Gagner le jeu",
      image: {src: null},
      text: ["Les emplacements individuels sont déverrouillés en choisissant les actions qui vous préparent le mieux pour les événements. Il y a beaucoup d’actions parmi lesquelles choisir; donc, n’abandonnez pas – quelques essais peuvent être nécessaires. Relevez avec succès les défis dans les six emplacements pour gagner le jeu. Si votre qualité de vie, votre état de préparation ou votre compte de banque tombe sous zéro, vous perdrez le jeu et devrez rejouer le même niveau.",
        "N’oubliez pas de partager vos résultats sur les médias sociaux et d’inviter vos amis à mettre à l’essai leurs connaissances en matière d’état de préparation!",
        "Vous êtes maintenant prêt à jouer!"],
    },

  ]
};


class Tutorial extends Component {
  render() {
    let index = parseInt(this.props.match.params.step, 10);
    let tutorialContent = tutorialPages[Locale.locale()][index - 1]; // Paths are 1-indexed
    let nextLink = (index === tutorialPages[Locale.locale()].length)? "/cities" : `/tutorial/${index + 1}`;
    let nextText = (index === tutorialPages[Locale.locale()].length)? "Let's Play!" : "Next";

    let styles = StyleSheet.create({
      image: {
        width: tutorialContent.image.width,
        height: tutorialContent.image.height,
        borderRadius: '10px',
        border: `6px solid ${Color.primary}`,
        boxShadow: '0px 0px 8px 6px rgba(0, 0, 0, 0.1)'
      },
      small: {
        fontSize: 32
      }
    });

    return(
      <div className={css(Layout.fullScrollingContentArea)}>
        <div className={css(Layout.contentArea)}>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
            <div className={css(Text.heading, Font.hero, tutorialContent.title.length > 8 && styles.small)}>{tutorialContent.title}</div>
            {tutorialContent.image.src && 
              <Image extraStyles={[Responsive.notOnMobile, styles.image]} filename={tutorialContent.image.src} />
            }
            <div className={css(Flexbox.grow, Text.textBlock)}>
              {tutorialContent.text.map(paragraph => {
                return <p key={paragraph}>{paragraph}</p>
              })}
            </div>
            <Link to={nextLink}>
              <PrimaryButton>{Locale.localized(nextText)}</PrimaryButton>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  componentDidUpdate() {
    ScrollFix();
  }

  componentDidMount() {
    ScrollFix();
  }
}

export default Tutorial;



// WEBPACK FOOTER //
// ./src/Tutorial.js